import { Formik, Form, Field } from "formik";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footers from "./Footer";
import { useState } from "react";
import Swal from "sweetalert2";
import { BiPhoneCall } from "react-icons/bi";

const Homeownerstrustus = () => {
    return (
        <>
            <motion.div
                className="page-wraper"
                style={{ background: "#fff" }}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
            >
                <Navbar />
                <div className="page-content">
                    {/* Banner Section */}
                    <motion.div
                        className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
                        data-stellar-background-ratio="0.5"
                        style={{ backgroundImage: "url(assets/pic/cms.jpg)" }}
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                    >
                        <div className="overlay-main bg-black opacity-07"></div>
                        <div className="container">
                            <div className="wt-bnr-inr-entry">
                                <div className="banner-title-outer">
                                    <div className="banner-title-name">
                                        <h2 className="text-white">Why Homeowners Trust Us </h2>
                                    </div>
                                </div>
                                <ul className="wt-breadcrumb breadcrumb-style-2">
                                    <li>
                                        <a href="/">Home</a>
                                    </li>
                                    <li>Why Homeowners Trust Us </li>
                                </ul>
                            </div>
                        </div>
                    </motion.div>

                    {/* Content Section */}
                    <motion.div
                        style={{ background: "#fff" }}
                        className="container mt-5 mb-5"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.3 }}
                    >
                        <div className="project-detail-outer" >
                            <div className="project-detail-containt">
                                <div className=" text-black">
                                    <h3 style={{ color: '#B19777', fontSize: '37px' }}>Bullets :-</h3>

                                    <ul style={{ fontSize: '20px', color: '#000 ', lineHeight: '50px' }}>
                                        <li style={{fontSize:'17px'}}>		<b>Over 10 Years of Experience </b>– We bring a decade of expertise in creating interiors that are both beautiful and practical</li>
                                        <li style={{fontSize:'17px'}}>		<b>Exceptional Quality </b>–  Every project is crafted with care, attention to detail, and premium finishes at our manufacturing unit </li>

                                        <li style={{fontSize:'17px'}}>		<b>10-Year Warranty  </b>–Enjoy complete peace of mind with every projectt</li>
                                        <li style={{fontSize:'17px'}}>		<b>	Affordable Pricing </b>– Interiors designed to fit your budget without compromising on style</li>
                                        <li style={{fontSize:'17px'}}>		<b>	Flexible Finance Options  </b>–Tailored solutions to help make your dream home a reality</li>
                                        <li style={{fontSize:'17px'}}> 		<b>Tailored solutions to help make your dream home a reality </b>– Each space is created to suit your lifestyle and personal needs</li>

                                        <li style={{fontSize:'17px'}}>		<b>Seamless Installation  </b>– Stress-free fitting, with finishing touches that make everything perfect</li>
                                        <li style={{fontSize:'17px'}}>		<b>Functional and Stylish Spaces  </b>– Practical, elegant, and truly yours</li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </motion.div>
                    {/* image start  */}
                    <motion.div className="section-full p-tb40">
                        <div className="container-fluid project-detail-pic">
                            <div className="row justify-content-center">
                                <div className="col-lg-4 col-md-6 m-b30">
                                    <div className="project-detail-pic ">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic3.jpg" alt="" /> */}
                                            <img src="/assets/pic/ab1.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 m-b30">
                                    <div className="project-detail-pic">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic3.jpg" alt="" /> */}
                                            <img src="/assets/pic/cms2.1.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-12 m-b30">
                                    <div className="project-detail-pic">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic3.jpg" alt="" /> */}
                                            <img src="/assets/pic/cms3.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-6 m-b30">
                                    <div className="project-detail-pic ">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic1.jpg" alt="" /> */}
                                            <img src="/assets/pic/cms4 (1).jpg" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-6 m-b30">
                                    <div className="project-detail-pic">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic2.jpg" alt="" /> */}
                                            <img src="/assets/pic/ab2.jpg" alt="" />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-12 m-b30">
                                    <div className="project-detail-pic">
                                        <div className="wt-media img-reflection">
                                            {/* <img src="assets/images/gallery/pic3.jpg" alt="" /> */}
                                            <img src="/assets/pic/cms6.webp" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                  
                  
                    

                 

                
                </div>
                <Footers />
                <button className="scroltop">
                    <span className="fa fa-angle-up  relative" id="btn-vibrate"></span>
                </button>
            </motion.div>
        </>
    )
}

export default Homeownerstrustus
